import { defineStore } from "pinia";

/**
 * Sidebar Count Store
 *
 * IMPORTANT: These counts represent TOTAL active counts and should be
 * INDEPENDENT of any filters applied to employee/position/role/responsibility lists.
 * The counts are updated via the /active-counts/ API endpoint which should
 * always return unfiltered totals.
 */
export const useSidebarCountStore = defineStore("sidebarCount", {
  state: () => ({
    employees: 0,
    positions: 0,
    roles: 0,
    responsibilities: 0,
    procedures: 0,
  }),

  getters: {
    getEmployeesCount: (state) => state.employees,
    getPositionsCount: (state) => state.positions,
    getRolesCount: (state) => state.roles,
    getResponsibilitiesCount: (state) => state.responsibilities,
    getProceduresCount: (state) => state.procedures,
    getAllCounts: (state) => ({
      employees: state.employees,
      positions: state.positions,
      roles: state.roles,
      responsibilities: state.responsibilities,
      procedures: state.procedures,
    }),
  },

  actions: {
    /**
     * Sets account counts from API response.
     * These counts should be independent of any filters.
     * @param {Object} counts - Object with employees, positions, roles, responsibilities, procedures counts
     */
    setAccountCounts(counts) {
      this.employees = counts.employees || 0;
      this.positions = counts.positions || 0;
      this.roles = counts.roles || 0;
      this.responsibilities = counts.responsibilities || 0;
      this.procedures = counts.procedures || 0;
    },

    resetCounts() {
      this.employees = 0;
      this.positions = 0;
      this.roles = 0;
      this.responsibilities = 0;
      this.procedures = 0;
    },
  },
});
